import hoursMap from 'helpers/hoursMap';

angular.module('gym.calendar').controller('WeeklyTrainersCtrl', ["$scope", "$state", "$rootScope", "$interval", "$filter", "loadingAnimation", "Trainers", "EmploymentService", "TrainersService", "EventService", "CalendarLastVisitedViewService", "CwStorage", "Availability", "GTMService", "locations", "selectedLocation", "eventTypes", "styles", function($scope, $state, $rootScope, $interval, $filter, loadingAnimation, Trainers, EmploymentService, TrainersService, EventService, CalendarLastVisitedViewService, CwStorage, Availability, GTMService, locations, selectedLocation, eventTypes, styles) {
  var displayCurrentTimeStripe, endTime, getAvailability, getDays, getTrainers, getTrainersDebounced, groupAvailabilities, groupEvents, gymConfig, onDateChanged, ref, ref1, renderTitle, startTime, tz;
  $scope.permissions = EmploymentService.get().permissions;
  if (!$scope.permissions.manage_other_contacts) {
    $state.go('gym.calendar');
  }
  CalendarLastVisitedViewService.set($state.current.name);
  $scope.date = moment();
  tz = $rootScope.gym.tz;
  gymConfig = $rootScope.gym.gym_config;
  $scope.unableToManageOtherContacts = !$scope.permissions.manage_other_contacts;
  $scope.eventTypes = eventTypes;
  $scope.styles = styles;
  $scope.locations = locations;
  $scope.instructors = TrainersService.get();
  $scope.selectedLocations = _.compact([selectedLocation]);
  $scope.selectedInstructors = [$scope.instructors[0]];
  $scope.selectedEventTypes = [];
  $scope.selectedStyles = [];
  GTMService.trackPage('Calendar Trainers Weekly');
  startTime = ((ref = gymConfig.calendar_display_hours_override) != null ? ref[0] : void 0) || 4;
  endTime = ((ref1 = gymConfig.calendar_display_hours_override) != null ? ref1[1] : void 0) - 1 || 23;
  $scope.hours = (function() {
    var results = [];
    for (var i = startTime; startTime <= endTime ? i <= endTime : i >= endTime; startTime <= endTime ? i++ : i--){ results.push(i); }
    return results;
  }).apply(this).map(function(num) {
    return hoursMap[num];
  });
  displayCurrentTimeStripe = (function() {
    var calculateStripePosition, currentTimeInterval, minutesInTimeSlot, startOfDay, timeSlotHeight;
    startOfDay = moment().startOf('day').add(startTime, 'hours');
    timeSlotHeight = 25;
    minutesInTimeSlot = 30;
    calculateStripePosition = function() {
      var currentTime, headerHeight, minutesFromStartOfDay;
      headerHeight = window.innerWidth <= 991 ? 42 : 0;
      currentTime = moment();
      minutesFromStartOfDay = currentTime.diff(startOfDay, 'minutes');
      $scope.currentTime = currentTime.format('h:mma');
      return $scope.currentTimePosition = minutesFromStartOfDay / minutesInTimeSlot * timeSlotHeight + headerHeight + 'px';
    };
    calculateStripePosition();
    currentTimeInterval = $interval(function() {
      return calculateStripePosition();
    }, 10000);
    return $rootScope.$on('$stateChangeStart', function() {
      return $interval.cancel(currentTimeInterval);
    });
  })();
  $scope.toDate = function(date) {
    $scope.date = date;
    return onDateChanged();
  };
  renderTitle = function() {
    var end, start;
    start = $scope.startDate.format('MMM D');
    end = $scope.endDate.format('MMM D YYYY');
    return $scope.title = `${start} — ${end}`;
  };
  onDateChanged = function() {
    $scope.startDate = $scope.date.clone().startOf('week');
    $scope.endDate = $scope.date.clone().endOf('week');
    renderTitle();
    getDays();
    getTrainers();
    return getAvailability();
  };
  getDays = function() {
    return $scope.days = [0, 1, 2, 3, 4, 5, 6].map(function(num) {
      var day;
      day = $scope.startDate.clone().add(num, 'days');
      return {
        label: day.format('ddd D'),
        key: day.format('DD-MM-YYYY'),
        isToday: angular.equals($filter('date')(new Date(), 'dd-MM-yyyy'), day.format('DD-MM-YYYY'))
      };
    });
  };
  $scope.showAttendees = function(event) {
    return EventService.showAttendees(event);
  };
  $scope.createAppointment = function(event, availability) {
    var minutesOfftes, params, time;
    minutesOfftes = Math.floor(event.offsetY / 25) * 30;
    time = availability.startMoment.clone().add(minutesOfftes, 'minutes').format('X');
    params = {
      time: time,
      location_id: availability.location_id,
      trainer_id: $scope.selectedInstructors[0].id
    };
    return EventService.addAppointment(params);
  };
  getTrainers = function() {
    var params, selectedEventType, selectedInstructor, selectedStyle;
    loadingAnimation.show();
    selectedLocation = $scope.selectedLocations[0] || {};
    selectedInstructor = $scope.selectedInstructors[0] || {};
    selectedEventType = $scope.selectedEventTypes[0] || {};
    selectedStyle = $scope.selectedStyles[0] || {};
    params = {
      start: $scope.startDate.startOf('day').format('X'),
      end: $scope.endDate.endOf('day').format('X'),
      location_id: selectedLocation.id,
      event_type_id: selectedEventType.id,
      style_id: selectedStyle.id,
      'trainer_ids[]': selectedInstructor.id
    };
    return Trainers.getList(params).then(function(trainers) {
      loadingAnimation.hide();
      groupEvents(trainers);
      return $scope.trainers = trainers;
    });
  };
  groupEvents = function(trainers) {
    var trainer;
    trainer = _.find(trainers, function(trainer) {
      return trainer.id === $scope.selectedInstructors[0].id;
    });
    trainer.events = trainer.events.map(function(event) {
      event.isCancelled = !!event.cancelled;
      return event;
    });
    return $scope.groupedEvents = _.groupBy(trainer.events, function(event) {
      return moment(event.start, 'YYYY/MM/DD HH:mm').format('DD-MM-YYYY');
    });
  };
  groupAvailabilities = function() {
    return $scope.groupedAvailabilities = _.chain($scope.availabilities).where({
      user_id: $scope.selectedInstructors[0].id
    }).groupBy(function(availability) {
      return moment(availability.availability_date, 'YYYY-MM-DD').format('DD-MM-YYYY');
    }).value();
  };
  getAvailability = function() {
    var endDate, params, startDate;
    startDate = moment($scope.startDate).format('YYYY-MM-DD');
    endDate = moment($scope.endDate).format('YYYY-MM-DD');
    params = {
      'filters[start_date]': startDate,
      'filters[end_date]': endDate,
      'count': 1000,
      '_': new Date().getTime()
    };
    return Availability.getList(params).then(function(data) {
      $scope.availabilities = data.plain().map(function(item) {
        item.classroom_name = item.location_name;
        item.start = moment(item.start_at).tz(tz).format('YYYY/MM/DD HH:mm');
        item.end = moment(item.end_at).tz(tz).format('YYYY/MM/DD HH:mm');
        return item;
      });
      return groupAvailabilities();
    });
  };
  $scope.isFiltersAvailable = function() {
    return $scope.locations.length > 1 || $scope.instructors.length > 1;
  };
  getTrainersDebounced = _.debounce(function() {
    return getTrainers();
  }, 300);
  $rootScope.$on('calendar:updated', function() {
    return getTrainers();
  });
  $scope.onLocationsChange = function(locations) {
    var location;
    location = locations[0] || {};
    CwStorage.setItem('selectedLocation', location.id);
    $scope.selectedLocations = locations;
    return getTrainersDebounced();
  };
  $scope.onInstructorsChange = function(instructors) {
    var instructor;
    instructor = instructors[0] || {};
    $scope.selectedInstructors = instructors;
    getTrainersDebounced();
    return groupAvailabilities();
  };
  $scope.onEventTypesChange = function(eventTypes) {
    $scope.selectedEventTypes = eventTypes;
    return getTrainersDebounced();
  };
  $scope.onStylesChange = function(styles) {
    $scope.selectedStyles = styles;
    return getTrainersDebounced();
  };
  return onDateChanged();
}]);
